module.exports = __webpack_public_path__ + "static/python-distilled-91b7956bfe61734863c2be54b3f909ce.jpeg";